"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextFieldTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NotificationIcon = _interopRequireDefault(require("../../../protons/icons/NotificationIcon"));

var _ButtonIcon = _interopRequireDefault(require("../../../atoms/buttons/buttonIcon/ButtonIcon"));

var _BoxPosition = _interopRequireDefault(require("../../../layouts/box/boxPosition/BoxPosition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  var _MuiInputLabelShr;

  return {
    formControl: {
      "& .MuiInputBase-root": {
        "& .MuiInputBase-input": _defineProperty({
          fontFamily: "Vodafone",
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
          height: theme.spacing(7.5),
          fontSize: theme.typography.h5.fontSize
        }, theme.breakpoints.down("xs"), {
          height: theme.spacing(6),
          fontSize: theme.typography.body1.fontSize
        })
      },
      "& .MuiFormLabel-root.MuiInputLabel-shrink": _defineProperty({
        fontSize: theme.typography.caption.fontSize
      }, theme.breakpoints.down("xs"), {
        fontSize: theme.typography.caption.fontSize
      }),
      "& .MuiFormLabel-root": _defineProperty({
        fontSize: theme.typography.h5.fontSize,
        fontFamily: "Vodafone"
      }, theme.breakpoints.down("xs"), {
        fontSize: theme.typography.body1.fontSize
      }),
      "& .MuiInputLabel-shrink": (_MuiInputLabelShr = {
        transform: "translate(14px, -6px)",
        color: theme.palette.text.primary,
        transition: theme.transitions.create(["font-size", "color", "transform"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shorter
        })
      }, _defineProperty(_MuiInputLabelShr, theme.breakpoints.down("xs"), {
        transform: "translate(14px, -11px)"
      }), _defineProperty(_MuiInputLabelShr, "&.Mui-focused", {
        color: theme.palette.secondary.main
      }), _defineProperty(_MuiInputLabelShr, "&.Mui-error", {
        color: theme.palette.error.main
      }), _MuiInputLabelShr),
      "& .MuiInputLabel-formControl": {
        "&.Mui-disabled": {
          color: theme.palette.text.disabled
        }
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 6,
        "& .MuiOutlinedInput-input": {
          padding: 0
        }
      },
      "& .MuiFormHelperText-root": {
        fontFamily: "Vodafone",
        color: theme.palette.text.secondary,
        fontSize: theme.typography.caption.fontSize,
        "&.Mui-error": {
          color: theme.palette.primary.main
        },
        "&.Mui-disabled": {
          color: theme.palette.text.disabled
        }
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.text.secondary
      }
    }
  };
});
/**
 * ** Input fields are used to enter and edit text. Hint text can be displayed to help uses understand what they need to enter in each field. **
 *
 */

var TextField = function TextField(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      type = _ref.type,
      value = _ref.value,
      _onChange = _ref.onChange,
      fullWidth = _ref.fullWidth,
      isValid = _ref.isValid,
      error = _ref.error,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      multiline = _ref.multiline,
      multilineRows = _ref.multilineRows,
      InputProps = _ref.InputProps,
      disabled = _ref.disabled;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    className: styles.formControl,
    fullWidth: fullWidth
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    variant: "outlined",
    label: label,
    placeholder: placeholder,
    type: type,
    value: value,
    disabled: disabled,
    fullWidth: fullWidth,
    error: error,
    onChange: function onChange(event) {
      return _onChange(event.currentTarget.value);
    },
    helperText: error ? errorText : helperText,
    multiline: multiline,
    rows: multilineRows,
    InputProps: _objectSpread({
      className: styles.input,
      endAdornment: /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "relative"
      }, /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "absolute",
        right: "zero",
        top: "nSmall"
      }, /*#__PURE__*/_react.default.createElement(_core.Fade, {
        in: error
      }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
        color: disabled ? "midGrey" : "red",
        icon: "ic_warning"
      })))), /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "absolute",
        right: "zero",
        top: "nSmall"
      }, /*#__PURE__*/_react.default.createElement(_core.Fade, {
        in: isValid && !error
      }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
        color: disabled ? "midGrey" : "green",
        icon: "ic_tick"
      })))), /*#__PURE__*/_react.default.createElement(_BoxPosition.default, {
        position: "absolute",
        right: "nMini",
        top: "nXl"
      }, /*#__PURE__*/_react.default.createElement(_core.Fade, {
        in: value !== "" && !error && !isValid
      }, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
        rounded: true,
        action: function action() {
          return _onChange("");
        },
        icon: "ic_close",
        variant: "tertiary",
        size: "large"
      })))))
    }, InputProps)
  }));
};

TextField.propTypes = {
  /** The floating label of the text field */
  label: _propTypes.default.string,

  /** The value of the field */
  value: _propTypes.default.string,

  /** The placeholder value of the field */
  placeholder: _propTypes.default.string,

  /** The type of the field (Html attribute) */
  type: _propTypes.default.oneOf(["text", "email", "number", "password", "tel", "date"]),

  /** Full width option of the input field */
  fullWidth: _propTypes.default.bool,

  /** The Disable state of the input field */
  disabled: _propTypes.default.bool,

  /** A Multiline option of the field */
  multiline: _propTypes.default.bool,

  /** Multiline field rows */
  multilineRows: _propTypes.default.number,

  /** The valid state of the field */
  isValid: _propTypes.default.bool,

  /** The error state of the field */
  error: _propTypes.default.bool,

  /** The Helper text value of the field */
  helperText: _propTypes.default.string,

  /** The Error text of the field. (Replaces helperText in case of error) */
  errorText: _propTypes.default.string,

  /** Props applied to the Input element */
  InputProps: _propTypes.default.object,

  /** Callback that returns the changed value */
  onChange: _propTypes.default.func
};
TextField.defaultProps = {
  label: null,
  value: null,
  placeholder: null,
  type: "text",
  fullWidth: false,
  disabled: false,
  multiline: false,
  multilineRows: 3,
  isValid: false,
  error: false,
  helperText: null,
  errorText: null,
  InputProps: null,
  onChange: null
};
var TextFieldTypes = ["text", "email", "number", "password", "tel", "date"];
exports.TextFieldTypes = TextFieldTypes;
var _default = TextField;
exports.default = _default;